export default "__VITE_PUBLIC_ASSET__ddda31d4__"